
import { Usuario } from "../despacho/Usuario";

export class AnulacionDTO {
    remitoId: string;
    motivo: string;
    usuario: Usuario
}